var jquery = require("jquery");
$ = window.$ = window.jQuery = jquery; // notice the definition of global variables here

// Add the Firebase services that you want to use
import firebase from "firebase/app";

import "firebase/auth";
import "firebase/analytics";
import "firebase/database";
import "firebase/firestore";

import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

//

if(window.document.documentMode){
    document.getElementById('main-preloader').innerHTML = '<div class="col s8 offset-s2"><h3>This browser is not supported. Please use Apple Safari, Mozilla Firefox, Microsoft Edge or Google Chrome</h3></div>';
}
if (window.location.href.indexOf("http://localhost") === -1){
    window.console.log = function(){
        console.info('© 2021, CMEfy @ SCAD.Ventures');
        window.console.log = function() {
            return false;
        }
    }
}

!(function() {
    // MIJI JSKJM
    var CURR_UserProfile;
    var CURR_UserAccountState;

    var CHECK_StripeCustomerStatus = false;

    $(document).ready((et)=>{
        $('#main-preloader').show();
        $('.auth-view').hide();
        $('.unauth-view').hide();
        //
        if (getUrlParameter('session_id') || getUrlParameter('checkSubscription')){
            CHECK_StripeCustomerStatus = true;
        }
        //
        InitializeUIElements();
        AUTH_FirebaseInitAndAuthCheck();
        //
    });

    var HELP_Timer = false;
    function InitializeUIElements(){
        //
        M.Sidenav.init(document.querySelectorAll('.sidenav'), {});
        //
        M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});
        //
        M.Collapsible.init(document.querySelectorAll('.collapsible'));
        // For first time users :) after a delay
        M.TapTarget.init(document.querySelectorAll('.tap-target'));
        //
        M.Carousel.init(document.querySelectorAll('.carousel'),{
            duration:0,
            dist: 0,
            indicators: true
        });
        // we need a listener on window closing
        M.Modal.init(document.querySelector('#faqModal'), {
            dismissible: true,
            opacity: 0.63,
            startingTop: '5%',
            endingTop: '5%'
        });
        //
        M.FloatingActionButton.init(document.querySelector('.fixed-action-btn'),{
            toolbarEnabled:false,
            hoverEnabled:false,
            direction: 'left'
        });
        M.FormSelect.init(document.querySelectorAll('select'), {});
        //
        M.Tabs.init(document.querySelectorAll('.tabs'), {
        });
        //
        M.Dropdown.init(document.querySelectorAll('.dropdown-trigger'));
    }

    // TASK MANAGER
    function UI_BindBtnTasks_Clicks(){
        $(document).on('click','.ui-action-btn', function(){
            return performUITask($(this).data("task"));
        });
    }

    function performUITask(task){
        
        switch (task){
            case "stripe::navigate-to-portal":
                window.location.href = STRIPE_PORTAL_URL;
                break;
            case "confirm-logout":
                M.toast({html: '<span>Logout?</span><button class="btn-flat toast-action ui-action-btn" data-task="logout-yes">Yes</button><button class="btn-flat toast-action ui-action-btn" data-task="logout-no">No</button>'})
                break;
            case "logout-yes":
                firebase.auth().signOut();
                window.location.reload();
                break;
            case "logout-no":
                M.Toast.dismissAll();
                break;
            default:
                console.log("No op");
                break;
        }

    }

    var STRIPE_PORTAL_URL = false;
    var CURR_UserAccountState = {};
    function UI_ProcessSubscriptionFlow(){
        FB_AuthGetToken(uidToken=>{
            if (uidToken){
                $.ajax({
                    url: `/v2_5/verify-cmefy-token?uidToken=${uidToken}`,
                    dataType: "json",
                    success: (userValid) => {
                        CURR_UserAccountState = userValid;
                        console.log(userValid);
                        if (CURR_UserAccountState.cmefy_account_type === "clinician" || CURR_UserAccountState.cmefy_account_type === "clinician-plus" || CURR_UserAccountState.cmefy_account_type === "clinician-catalyst"){
                            M.toast({html:"Sorry, this feature is only available for the Leader tier..."});
                            setTimeout(()=>{
                                return window.location.href = "/subscribe";;
                            }, 1800);
                        }else{
                            $('#iframe-preloader').remove();
                            return $('#retool_dash-iframe').attr('src', `https://adaptrack.retool.com/embedded/public/93a79311-1c35-4d1e-b27e-2d4c272df65e#usertoken=${uidToken}`)
                        }
                    },
                    error: function(err){
                        ERROR_Alerter(err);
                        firebase.auth().signOut();
                    }
                });
            }
        });
    }

    function remove_duplicates(arr) {
        var obj = {};
        var ret_arr = [];
        for (var i = 0; i < arr.length; i++) {
            obj[arr[i]] = true;
        }
        for (var key in obj) {
            ret_arr.push(key);
        }
        return ret_arr;
    }

    // AUTH Master
    function AUTH_FirebaseInitAndAuthCheck(){
        var firebaseConfig = {
            apiKey: "AIzaSyAGwxNtQFoExfy5h6QwsiXtRufkecGdKjo",
            authDomain: "cmefy-platform.firebaseapp.com",
            projectId: "cmefy-platform",
            storageBucket: "cmefy-platform.appspot.com",
            messagingSenderId: "920328618854",
            appId: "1:920328618854:web:09e10fa0f1e4ae21fdfea7",
            measurementId: "G-D6L8YYD6QE"
        };
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
        //
        // Auth Checking Eventbased :)
        firebase.auth().onAuthStateChanged(function(user) {
            AUTH_CheckAndProceed(user);
        });
    }

    function AUTH_CheckAndProceed(user){
        if (user) {
            // check & show auth view
            if (getUrlParameter('logout')){ // search a nudge by text
                firebase.auth().signOut();
                history.pushState({},"CMEfy | Catalyzing Clinician Co-learning","/")
                window.location.reload();
            }
            //
            showAuthView();
            UI_BindBtnTasks_Clicks();
            //
            console.log(`user is valid`);
            //
            return UI_ProcessSubscriptionFlow();
        }else{
            window.location.href = 'https://about.cmefy.com'
        }
    }

    function FB_LogEvent(event, packet){
        firebase.analytics().logEvent(event, packet);
    }

    function showAuthView(){
        $('#main-preloader').hide();
        //
        $('.auth-view').show();
        $('.unauth-view').hide();
    }
    

    function ERROR_Alerter(errObj){
        if (errObj){
            console.log(errObj);
            if (errObj.error){
                alert(JSON.stringify(errObj.error));
            }else{
                alert(JSON.stringify(errObj));
            }
        }else{
            alert("There was an error in your connection, please refresh this page.");
        }
    }

    function navigateToApp(){
        window.location.href = "/app";
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    function animateCSS(element, animationName, callback) {
        const node = document.querySelector(element)
        node.classList.add('animated', animationName)

        function handleAnimationEnd() {
            node.classList.remove('animated', animationName)
            node.removeEventListener('animationend', handleAnimationEnd)

            if (typeof callback === 'function') callback()
        }

        node.addEventListener('animationend', handleAnimationEnd)
    }

    function FB_AuthGetToken(callback){
        firebase.auth().currentUser.getIdToken(true).then(function(idToken) {
            // Send token to your backend via HTTPS
            return callback(idToken);
            // ...
        }).catch(function(error) {
            // Handle error
            return callback(false);
        });
    }
})();